import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRotateLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#292a33"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 10 6 6.5 12 3v3a7 7 0 1 1-7 7h.933A6.067 6.067 0 1 0 12 6.933z" />
  </svg>
);
export default SvgRotateLeft;
